import * as React from 'react'
import { injectStripe } from 'react-stripe-elements'
import { FormFor } from 'react-rails-form-helpers'
import { CustomerForm } from '../../Checkout/Customer/CustomerForm'
import { ControlMembershipCheckoutForm, IProps as IOriginalProps } from '../../Checkout/MembershipCheckoutForm'
import { Testimonials } from '../../Checkout/Testimonials'
import { StripePaymentForm } from './StripePaymentForm'
import { TwoYearCart } from './TwoYearCart'
import { TwoYearTermsOfService } from './TwoYearTermsOfService'

declare var Routes: any

interface IStripeObject {
  paymentRequest: stripe.Stripe['paymentRequest']
  createToken(options?: stripe.TokenOptions): Promise<stripe.TokenResponse>
  createSource(sourceData?: stripe.SourceOptions): Promise<stripe.SourceResponse>
}

interface IProps extends IOriginalProps {
  stripe?: IStripeObject
}

class TwoYearCheckout extends ControlMembershipCheckoutForm {
  private stripeTokenFieldRef = React.createRef<HTMLInputElement>()
  private submitButtonRef = React.createRef<HTMLButtonElement>()

  public render() {
    const { checkout, taxInformation } = this.state
    const {
      cashier,
      testimonials,
    } = checkout
    const selectedPurchaseOption = this.selectedPurchaseOption()
    const {
      terms_of_service: termsOfService,
    } = cashier
    const {
      paymentDetails,
    } = selectedPurchaseOption
    const { newMembershipPlanDates } = checkout

    return (
      <div className="checkout membership-checkout cyber-monday">
        <div className="grid-x">
          <header className="cell">
            <h1>2-Year Pro Membership</h1>
          </header>
        </div>
        <div className="grid-container wide">
          <div className="grid-x">
            <div className="cell small-full mlarge-30 small-order-2 mlarge-order-1 checkout-form">
              <FormFor
                onSubmit={this.handleSubmit}
                url={Routes.igniter_two_year_checkout_path()}
                method="post"
                name="cashier"
              >
                <input
                  type="hidden"
                  name="cashier[stripe_token]"
                  ref={this.stripeTokenFieldRef}
                />

                {this.cashierErrors()}
                {this.renderCustomerForm()}
                {this.renderAddress()}

                <StripePaymentForm />

                <TwoYearTermsOfService
                  termsOfService={termsOfService}
                  paymentDetails={paymentDetails}
                  taxInformation={taxInformation}
                  submitButtonRef={this.submitButtonRef}
                  ctaText={this.ctaText()}
                  newMembershipPlanDates={newMembershipPlanDates}
                />
              </FormFor>

              <Testimonials testimonials={testimonials} />
            </div>

            <div className="cell small-full mlarge-30 small-order-1 mlarge-order-2 order-preview">
              <TwoYearCart
                purchaseOption={selectedPurchaseOption}
                trialActivationPrice={0}
                trial={false}
                trialLength={0}
                taxInformation={taxInformation}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  private renderCustomerForm() {
    const { checkout: { signed_in: signedIn } } = this.props

    if (signedIn) { return }

    return (
      <CustomerForm />
    )
  }

  private handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    const { stripe } = this.props as IProps
    const { current: stripeTokenField } = this.stripeTokenFieldRef
    const { current: submitButton } = this.submitButtonRef
    const formElement = event.currentTarget

    if (submitButton) {
      submitButton.disabled = true
      submitButton.value = 'Please Wait...'
    }

    event.preventDefault()

    if (!stripe) {
      throw new Error('Stripe object not defined!')
    }

    const { token, error } = await stripe.createToken({})

    if (token) {
      if (!stripeTokenField) {
        throw new Error('Stripe Token field is not found!')
      }

      stripeTokenField.value = token.id
      formElement.submit()
    } else if (error) {
      const { checkout } = this.state

      if (submitButton) {
        submitButton.disabled = false
        submitButton.value = this.ctaText()
      }

      this.setState({
        checkout: {
          ...checkout,
          cashier: {
            ...checkout.cashier,
            errors: {
              ...checkout.cashier.errors,
              base: error.message,
            },
          },
        },
      })
    }
  }
}

const TwoYearCheckoutWithStripe = injectStripe(TwoYearCheckout)

export { TwoYearCheckoutWithStripe as TwoYearCheckout }
